export default __webpack_public_path__ + "e22cab9.png";